import {apiVersion} from '.';

const v2BaseURL = `${apiVersion.v2}/`;

export const {livenessVerification, livenessAdvancedVerification} = {
    livenessVerification: `${v2BaseURL}IdentityVerification/LivenessCheck`,
    livenessAdvancedVerification: `${v2BaseURL}IdentityVerification/LivenessCheckAdvanced`,
};
